import * as Keyboard from "../keyboard";

window.addEventListener("live-autocomplete-input:mounted", (event) => {
  const autocompleteEl = event.target;

  const searchInputEl = autocompleteEl.querySelector(".js-text-input");
  const optionsEl = autocompleteEl.querySelector(".js-autocomplete-options");

  Keyboard.initListNavigation({
    containerEl: optionsEl,
    triggerEl: searchInputEl,

    handle(event) {
      if (event.key === "Escape") {
        hideOptions(optionsEl);
        return true;
      }
    },
  });
});

function hideOptions(optionsEl) {
  optionsEl.style.display = "none";
}
